import http from './http';

const ENDPOINTS = {
  NOTES: '/api/v1/notes',
  NOTE_BY_ID: (id) => `/api/v1/notes/${id}`,
};

/**
 * Notes API Service
 */
export const notesAPI = {
  // Create a new note
  create: async (noteData) => {
    const response = await http.post(ENDPOINTS.NOTES, noteData);
    return response.data;
  },

  // Get note by ID
  getById: async (id) => {
    const response = await http.get(ENDPOINTS.NOTE_BY_ID(id));
    return response.data;
  },

  // Update note
  update: async (id, noteData) => {
    const response = await http.patch(ENDPOINTS.NOTE_BY_ID(id), noteData);
    return response.data;
  },

  // List notes with filtering
  list: async (params = {}) => {
    const response = await http.get(ENDPOINTS.NOTES, { params });
    return response.data;
  },

  // Delete note (soft delete)
  delete: async (id) => {
    const response = await http.delete(ENDPOINTS.NOTE_BY_ID(id));
    return response.data;
  }
};

export default notesAPI;
